import { namespacedConsts, } from 'utils/object';

export const FANTASY_ACTION_TYPES = namespacedConsts({
  TOURNAMENT: {
    LOAD_MORE: true,
    GET_TOURNAMENTS_FEED: true,
    SELECT_TOURNAMENT: true,
  },
});


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/fantasyActionTypes.js